































import { Vue, Component } from 'vue-property-decorator';
import InspectionTemplatePreview from './inspectionTemplatePreview.vue';
import InspectionTemplateEdit from './inspectionTemplateEdit.vue';
import * as api from '@/api';

@Component({
    components: {
        InspectionTemplatePreview,
        InspectionTemplateEdit
    }
})
export default class InspectionTemplate extends Vue {
    btnLoading: boolean = false;
    isEditState: boolean = true;
    $refs: any;
    inspectionForm: CommonTypes.mapObject = {
        systemFields: [],
        deduction: []
    };
    basicForm: CommonTypes.mapObject = {
        name: '',
        desc: ''
    };

    created() {
        this.formId ? this.getTemplateValues() : this.initForm();
    }
    initForm() {
        this.inspectionForm = {
            systemFields: [
                {
                    fieldType: 'SYSTEM',
                    name: 'totalPoints',
                    value: 100,
                    valueType: 'NUMERIC'
                },
                {
                    fieldType: 'SYSTEM',
                    name: 'noteSwitch',
                    value: false,
                    valueType: 'BOOLEAN'
                },
                {
                    fieldType: 'SYSTEM',
                    name: 'noteRequired',
                    value: false,
                    valueType: 'BOOLEAN'
                }
            ],
            deduction: []
        };
    }
    validateForm() {
        const editComponent = this.$refs.inspectionEdit;
        if (editComponent) {
            const basicForm = editComponent.$refs.inspectionTotalForm || {};
            const deductionForm = editComponent.$refs.inspectionDeduction || {};
            Promise.all([basicForm.validate(), deductionForm.validateDeduction()])
                .then(() => {
                    if (!this.inspectionForm.deduction.length) {
                        this.$mtd.message({
                            type: 'error',
                            message: '请填写扣分项'
                        });
                        return;
                    }
                    this.formId ? this.editTemplate() : this.createTemplate();
                })
                .catch(e => {
                    console.log(e);
                });
        }
    }
    async editTemplate() {
        const res = await api.inspectApi.editInspectTemplate({
            name: this.basicForm.name,
            desc: this.basicForm.desc,
            objectId: this.spaceId,
            field: this.handleFormToData(),
            id: this.formId,
            version: this.version
        });
        const { code } = res;
        if (code === 200) {
            this.$mtd.message.success('编辑模板成功');
            // 跳转列表页
            this.$router.push(`/space/${this.spaceId}/quality-inspection-template`).catch(e => e);
        }
    }
    async createTemplate() {
        const res = await api.inspectApi.createInspectTemplate({
            name: this.basicForm.name,
            desc: this.basicForm.desc,
            objectId: this.spaceId,
            field: this.handleFormToData()
        });
        const { code } = res;
        if (code === 200) {
            this.$mtd.message.success('创建模板成功');
            // 跳转列表页
            this.$router.push(`/space/${this.spaceId}/quality-inspection-template`).catch(e => e);
        }
    }
    async getTemplateValues() {
        // 根据formId查询模板数据，进行回显
        const res = await api.inspectApi.getTemplateDetail({
            templateId: this.formId,
            templateVersion: this.version
        });
        const { code, data } = res;
        if (code === 200) {
            this.handleDataToForm(data);
        }
    }
    handleDataToForm(data: any) {
        data.field.forEach(item => {
            if (item.fieldType === 'SYSTEM') {
                if (item.valueType === 'BOOLEAN') {
                    item.value = item.value === 'true';
                }
                this.inspectionForm.systemFields.push(item);
            } else {
                item.value = Number(item.value);
                this.inspectionForm.deduction.push(item);
            }
        });
        this.basicForm = {
            name: data.name,
            desc: data.desc
        };
    }
    handleFormToData() {
        return this.inspectionForm.systemFields.concat(this.inspectionForm.deduction);
    }
    async preview() {
        const editComponent = this.$refs.inspectionEdit;
        if (editComponent) {
            await (editComponent.$refs.inspectionDeduction || {}).validateDeduction();
            this.isEditState = false;
        }
    }
    handleClick() {
        if (this.isEditState) {
            // 编辑态为保存操作，校验表单
            this.validateForm();
        } else {
            // 预览态为关闭预览操作，变为编辑态
            this.isEditState = true;
        }
    }
    // 模板配置项修改
    handleTemplateChanged(part, val) {
        if (['noteRequired', 'noteSwitch', 'totalPoints'].includes(part)) {
            this.inspectionForm.systemFields.find(item => {
                if (item.name === part) {
                    item.value = val;
                    if (item.id) delete item.id;
                    return true;
                }
            });
        } else {
            this.$set(this.inspectionForm, part, val);
        }
    }
    // 基本信息修改
    handleBasicChange(type, val) {
        this.$set(this.basicForm, type, val);
    }
    // 取消编辑
    cancelBack() {
        this.$mtd
            .confirm({
                message: '确定要离开吗？系统可能不会保存您所做的更改',
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: '确定',
                className: 'cancel-confirm',
                onOk: () => {
                    this.$router.push(`/space/${this.spaceId}/quality-inspection-template`).catch(e => e);
                }
            })
            .catch(e => e);
    }
    get spaceId() {
        return parseInt(this.$route.query.spaceId as string, 10);
    }
    get formId() {
        return parseInt(this.$route.query.formId as string, 10);
    }
    get version() {
        return parseInt(this.$route.query.version as string, 10);
    }
    get headerTitle() {
        return this.isEditState ? (this.formId ? '编辑质检模板' : '添加质检模板') : '质检模板预览';
    }
}
